import moment from "moment";
import {
  AppointmentMetadata,
  GetOneAppointmentResponseService,
  ResponseMetadata,
} from "../../../../services/TurnServices/Turns.type";
import { SelectionMetadata } from "../../requestTurn/requestedTurn.type";

export const getAppointmentToUpdateInfo = (
  appointment: GetOneAppointmentResponseService,
) => ({
  molde: appointment.metadata.molde,
  exam: appointment.metadata.exam,
  practicesSelected: appointment.metadata.practices,
  date: appointment?.date
    ? moment(appointment?.date, "DD/MM/YYYY").toDate()
    : undefined,
  comments: appointment?.observations ? appointment?.observations : undefined,
  hour: appointment?.startTime
    ? {
      value: appointment?.startTime,
      name: `${appointment?.startTime}`,
      id: `${appointment.id}-${appointment?.startTime}`,
    }
    : undefined,
  has_cm: appointment?.has_cm,
  professional_cm: appointment?.professional_cm,
  professional_license_cm: appointment?.professional_license_cm,
  cm_date: appointment?.cm_date,
  cm_days: appointment?.cm_days,
});

export const getBasicMetadata = (
  completeMeta: ResponseMetadata | SelectionMetadata,
): AppointmentMetadata => ({
  molde: completeMeta.molde?.id,
  exam: completeMeta.exam?.id,
  practices: completeMeta.practices?.map((practice) => practice.id),
});
